import { SettingsContext } from '@f_qwep/context/Settings_context';
import React, { useContext, useEffect, useState } from 'react';
import { AccountsContext } from '@f_qwep/context/Accounts_context';
import GeneralJoyride from '../GeneralJoyride';
import { PriceContext } from '@f_qwep/context/Price_context';
import { ManualContext } from '@f_qwep/context/Manual_context';
import { IconMaskot } from '@f_components/icons/IconMascot';

export function AddPriceManual() {
    const { openAdd } = useContext(PriceContext);
    const { setChooseManual, newManualValue, setNewManualValue } = useContext(ManualContext);

    const [run, setRun] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [steps, setSteps] = useState<any>([
        {
            target: '#prices',
            content: (
                <div>
                    <IconMaskot />
                    <p>Перейдите в раздел "Прайсы"</p>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#addNewPrice',
            content: 'Нажмите на кнопку для загрузки нового прайса',
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: '#switchAddPrice',
            content: 'Выберите тип файла',
            disableBeacon: true,
            hideFooter: false,
            spotlightClicks: false,
        },
        {
            target: '#priceFileInput',
            content: 'Заполните все поля и загрузите файл. По окончании загрузки Прайс необходимо классифицировать.',
            disableBeacon: true,
            hideFooter: false,
            spotlightClicks: false,
        },
    ]);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/' || window.location.pathname == '/app-qwep') {
            setRun(true);
            if (!newManualValue?.prices?.flag) {
                setNewManualValue({ ...newManualValue, prices: { flag: true } });
            }
        }
    }, []);

    useEffect(() => {
        if (openAdd) {
            setCurrentStep((prevStep) => prevStep + 1);
        }
    }, [openAdd]);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/prices') {
            setCurrentStep((prevStep) => prevStep + 1);
        }
    }, [window.location.pathname]);

    const handleJoyrideCallback = (data: any) => {
        const { action, step, index, status, type } = data;

        if (type === 'step:after' && action === 'next' && !step.hideFooter) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else if (type === 'step:before') {
        } else if (
            type === 'step:after' &&
            (action === 'skip' || action === 'close' || action === 'last' || action === 'skip')
        ) {
            setCurrentStep(0);
            setRun(false);
            setChooseManual();
        }
    };

    return (
        <div>
            <GeneralJoyride steps={steps} run={run} callback={handleJoyrideCallback} stepIndex={currentStep} />
        </div>
    );
}
